import {
  Camera,
  Music,
  Speaker,
  UtensilsCrossed,
  Sparkles,
  CakeSlice,
  Shirt,
  Brush,
  Flower2,
  PartyPopper,
} from 'lucide-react';

// Keyword → lucide icon. First match wins, so order the more specific rules first.
const RULES = [
  [/photo|video/i, Camera],
  [/\bdj\b|music/i, Music],
  [/sound|audio|speaker|pa\b/i, Speaker],
  [/cater|food|cook|kitchen/i, UtensilsCrossed],
  [/decor|throne|stage|flower.*arrang/i, Sparkles],
  [/cake|bake|pastry|dessert/i, CakeSlice],
  [/fashion|dress|tailor|cloth|design(?!.*event)/i, Shirt],
  [/makeup|beauty|hair|salon|groom/i, Brush],
  [/henna|mehnd/i, Flower2],
];

/**
 * Pick an on-brand lucide icon for a category from its name or slug.
 * Falls back to a celebratory default so every category always has an icon.
 * @param {string} nameOrSlug
 * @returns {import('lucide-react').LucideIcon}
 */
export function getCategoryIcon(nameOrSlug = '') {
  const value = String(nameOrSlug);
  for (const [pattern, Icon] of RULES) {
    if (pattern.test(value)) return Icon;
  }
  return PartyPopper;
}

/**
 * True when `url` is a usable uploaded image (not empty and not a placeholder
 * service), so callers can fall back to a lucide icon otherwise.
 * @param {string} [url]
 */
export function hasRealImage(url) {
  return Boolean(url) && !/placehold\.co|placeholder|via\.placeholder/i.test(url);
}
